const FilesAndLinks = () => import(/* webpackChunkName: "qraccess" */ "../../views/filesAndLinks/FilesAndLinks")
const S3Uploads = () => import(/* webpackChunkName: "trips" */ "../../views/filesAndLinks/UploadFiles/S3Uploads.vue")

const qrAcessRoutes = [{
  path: "filesAndLinks",
  name: "Files and Links",
  redirect: {
    name: "S3 Uploads"
  },
  component: FilesAndLinks,
  children: [{
      path: "s3Uploads",
      name: "S3 Uploads",
      component: S3Uploads,
      props: true
    }
  ]
}];

export default qrAcessRoutes;
